import LeadForm from "@/components/site/LeadForm";

export default function LeadFormSection({ forwardedRef }) {
  return (
    <section
      id="lead-form"
      data-testid="lead-form-section"
      ref={forwardedRef}
      className="relative py-20 lg:py-28 bg-[#F9F8F6]"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[80%] h-72 bg-[#F1EDE7] rounded-[40px] opacity-60 blur-2xl" />
      </div>
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <LeadForm variant="section" />
      </div>
    </section>
  );
}
